@if (sources.length > 0 && sources[0].s3FileVersionGUID !== null) {
	<div class="source-citations" data-testid="source-citation-container">
		<div class="sources-header">
			<button class="sources-toggle" (click)="toggleExpanded()" data-testid="source-citation-btn-toggle">
				<mat-icon class="evidence-icon">verified</mat-icon>
				<span class="toggle-text">Sources cited</span>
				<mat-icon class="toggle-chevron" [class.expanded]="expanded">expand_more</mat-icon>
			</button>
		</div>

		@if (expanded) {
			<div class="evidence-list" data-testid="source-citation-panel-evidence">
				@for (group of groupedSources; track group.s3FileVersionGUID) {
					<div class="evidence-card">
						<!-- Document header -->
						<div class="evidence-card-header">
							<mat-icon class="doc-icon">{{ group.icon }}</mat-icon>
							<span class="evidence-title">{{ group.title }}</span>
						</div>
						<div class="evidence-meta">
							<span class="evidence-badge evidence-badge--provenance">{{ group.provenance }}</span>
						</div>

						<!-- Matches summary -->
						<div class="evidence-matches-label">Matches Found</div>

						<!-- Quoted excerpts -->
						<div class="evidence-quotes">
							@for (quote of getVisibleExcerpts(group); track quote) {
								<blockquote class="evidence-quote">"{{ truncateQuote(quote) }}"</blockquote>
							}
						</div>

						<!-- Show more/less -->
						@if (hasMoreExcerpts(group)) {
							<button class="evidence-show-more" (click)="toggleGroup(group.s3FileVersionGUID)" data-testid="source-citation-btn-show-more">
								View All {{ group.excerpts.length }} Mentions
							</button>
						}
						@if (expandedGroups.has(group.s3FileVersionGUID) && group.excerpts.length > 3) {
							<button class="evidence-show-more" (click)="toggleGroup(group.s3FileVersionGUID)" data-testid="source-citation-btn-show-less">Show Less</button>
						}

						<!-- View in Document link -->
						<button class="evidence-view-link" (click)="onViewDocument(group)" [disabled]="loadingDocUri === group.s3FileVersionGUID" data-testid="source-citation-btn-view-document">
							@if (loadingDocUri !== group.s3FileVersionGUID) {
								<span>[View in Document]</span>
							}
							@if (loadingDocUri === group.s3FileVersionGUID) {
								<span>Loading...</span>
							}
						</button>
					</div>
				}
			</div>
		}
	</div>
}
